import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import vSelect from 'vue-select'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

import api from '@/helpers/fetch'

@Component({
	components: {
		vSelect,
		TypeableDatePortal,
	},
})
export default class EntryModal extends Vue {
	@Prop({ required: true, type: Object }) item!: any

	localItem: any = {}
	loading = false

	options = {
		type: ['N', 'C'],
		situation: ['A vencer', 'Parcial', 'Quitado', 'Vencido'],
	}

	get title() {
		if (this.localItem.id && !isNaN(this.localItem.id)) {
			return 'Editar lançamento'
		} else {
			return 'Novo lançamento'
		}
	}

	@Watch('item', { immediate: true, deep: true })
	onItemChange(newVal: any) {
		this.localItem = { ...newVal }
	}

	async send() {
		const payload = {
			work_regime: this.localItem.work_regime,
			type: this.localItem.type,
			situation: this.localItem.situation,
			acquisition_period_start: this.localItem.acquisition_period_start,
			acquisition_period_end: this.localItem.acquisition_period_end,
			usage_period_start: this.localItem.usage_period_start,
			usage_period_end: this.localItem.usage_period_end,
			allowance_period_start: this.localItem.allowance_period_start,
			allowance_period_end: this.localItem.allowance_period_end,
			date_limit: this.localItem.date_limit,
			used_days: this.localItem.used_days,
			balance: this.localItem.balance,
			user_id: this.localItem.user_id,
		}

		let url = '/api/vacations'
		if (this.localItem.id) {
			url += '/update/others/' + this.localItem.id
		}

		this.loading = true
		const res = await api.post(url, payload)
		this.loading = false

		if (res.ok) {
			this.$bvToast.toast('Operação realizada com sucesso!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			this.$emit('change')
			this.$bvModal.hide('entry-modal')
		} else {
			this.$bvToast.toast('Não foi possível concluir operação', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}

	handleCancel() {
		this.$emit('cancel')
		this.$bvModal.hide('entry-modal')
	}
}
